import repository from "@/repository/repository";

class Logs {
    static save(page, errors, payload) {
        repository.post("/errors", {
            'page': page,
            'errors': errors,
            'payload': payload,
        });
    }
}

export default Logs;